import React from "react";
import { PINTS_EVENTS } from "./pintsEvents";
import PintsSunsetPage from "./PintsSunsetPage";

export default function HorseThief() {
  return <PintsSunsetPage event={PINTS_EVENTS.horseThief} />;
}
